import PropTypes from 'prop-types';
import React from 'react';
import Link from '../../../shared/components/Link';
import trackingAdapter from '../tracking/trackingAdapter';
import { referAsPropertyTile } from '../util/referrerService';
import styles from './PropertyTypeItem.scss';
import { preparePropertyType } from '../constants/exploreByPropertyOptions';
import { getIconForPropertyType } from '../constants/propertyTypeIcon/PropertyTypeIcon';
import { PROPERTY_TYPE_OBJECT_PROP_TYPES, CHANNEL_PROP_TYPES } from '../../../shared/model/types';

const PropertyTypeItem = ({
  className,
  currentChannel,
  propertyTypeObject,
}) => {
  const { title, path } = preparePropertyType(propertyTypeObject);
  const handleClick = () => {
    trackingAdapter.trackPropertyTypeClick({ channelObject: currentChannel, propertyTypeObject });
    referAsPropertyTile();
  };
  const Icon = getIconForPropertyType(propertyTypeObject);

  return (
    <Link
      className={className}
      href={`/${currentChannel.url}/${path}/`}
      onClick={handleClick}
    >
      <div className={styles.icon}>
        <Icon />
      </div>
      <span className={styles.title}>
        {title}
      </span>
    </Link>
  );
};

PropertyTypeItem.propTypes = {
  className: PropTypes.string.isRequired,
  currentChannel: CHANNEL_PROP_TYPES.isRequired,
  propertyTypeObject: PROPERTY_TYPE_OBJECT_PROP_TYPES.isRequired,
};

export default PropertyTypeItem;
